import React from 'react';
import * as StyledNavigationalCard from './navigationalCard.styles';
import {
	H2
} from '../base';

const NavigationalCard = ({
	Title,
	Image,
	Urls,
	Color
}) => {
	return (
		<StyledNavigationalCard.Wrapper>
			<StyledNavigationalCard.Line backgroundColor={Color} />
			<H2 marginBottom="3rem">{Title}</H2>
			{
				Urls.map(item => (
					<StyledNavigationalCard.Link to={item.Url} key={item.Id}>{item.Name}</StyledNavigationalCard.Link>
				))
			}
			<StyledNavigationalCard.Image src={Image.Src} />
		</StyledNavigationalCard.Wrapper>
	);
};

export default NavigationalCard;
